import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import MemoryGame from './components/MemoryGame';
import LeaderBoard from './components/LeaderBoard';
import PhotoGuidelinesFlyer from './components/PhotoGuidelinesFlyer';
import FlyerPage from './components/FlyerPage';
import BadgePage from './components/BadgePage';
import InstallPrompt from './components/InstallPrompt';
import './App.css';

function App() {
  useEffect(() => {
    // Don't register service worker on localhost (avoids cache/503 issues when port or build changes)
    const isLocalhost = /localhost|127\.0\.0\.1/.test(window.location.hostname);
    if (isLocalhost && 'serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(reg => reg.unregister());
      });
      return;
    }
    // Register service worker in production only
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        // First, unregister ALL existing service workers
        navigator.serviceWorker.getRegistrations().then(registrations => {
          registrations.forEach(registration => {
            registration.unregister();
            console.log('Unregistered old service worker');
          });
          
          // Then register new one
          navigator.serviceWorker.register('/sw.js')
            .then((registration) => {
              console.log('SW registered: ', registration);
              
              // Check for updates every time the app loads
              registration.addEventListener('updatefound', () => {
                const newWorker = registration.installing;
                newWorker.addEventListener('statechange', () => {
                  if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                    // New service worker is available, force it to activate
                    newWorker.postMessage({ type: 'SKIP_WAITING' });
                    // Reload the page to use the new service worker
                    window.location.reload();
                  }
                });
              });
              
              // Also check for updates periodically
              setInterval(() => {
                registration.update();
              }, 60000); // Check every minute
            })
            .catch((registrationError) => {
              console.log('SW registration failed: ', registrationError);
            });
        });
      });
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/game" element={<MemoryGame />} />
          <Route path="/leaderboard" element={<LeaderBoard />} />
          <Route path="/photo-guidelines" element={<PhotoGuidelinesFlyer />} />
          <Route path="/flyer" element={<FlyerPage />} />
          <Route path="/badge/:gameId" element={<BadgePage />} />
        </Routes>
        <InstallPrompt />
      </div>
    </Router>
  );
}

export default App;
